import clsx from "clsx";
import { ReactNode } from "react";

const gapMap: Record<string, string> = {
  "050": "gap-0.5",
  "100": "gap-1",
  "200": "gap-2",
  "300": "gap-3",
  "400": "gap-4",
  "500": "gap-5",
  "800": "gap-8",
  "1000": "gap-10",
  "0": "gap-0",
};

const alignMap: Record<string, string> = {
  center: "justify-center",
  start: "justify-start",
  end: "justify-end",
  baseline: "justify-baseline",
  stretch: "justify-stretch",
  "space-between": "justify-between",
};

const itemsAlignMap: Record<string, string> = {
  center: "items-center",
  start: "items-start",
  end: "items-end",
  baseline: "items-baseline",
  stretch: "items-stretch",
};

export function InlineStack(props: {
  children: ReactNode;
  gap?: string;
  align?: string;
  blockAlign?: string;
  as?: React.ElementType;
}) {
  const Component = props.as ?? "div";

  return (
    <Component
      className={clsx("flex flex-wrap", {
        [gapMap[props.gap || "400"]]: props.gap,
        [alignMap[props.align || ""]]: props.align,
        [itemsAlignMap[props.blockAlign || ""]]: props.blockAlign,
      })}
    >
      {props.children}
    </Component>
  );
}

export function BlockStack(props: {
  children: ReactNode;
  gap?: string;
  inlineAlign?: string;
  align?: string;
  as?: React.ElementType;
}) {
  const Component = props.as ?? "div";
  return (
    <Component
      className={clsx("flex flex-col", {
        [gapMap[props.gap || "400"]]: props.gap,
        [itemsAlignMap[props.inlineAlign || ""]]: props.inlineAlign,
        [itemsAlignMap[props.align || ""]]: props.align,
      })}
    >
      {props.children}
    </Component>
  );
}
